import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RSVPInvitationPage_pooja } from "../../RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";

const ChooseTemplateDialog = ({
  visible,
  onHide,
  selectedTemplate,
  setSelectedTemplate,
  selectedTemplateError,
  handleTemplateSubmit,
  imageloading,
  eventimages,
  currentIndex,
  handlePrev,
  handleNext,
  imagetemplateslength,
  EventDataForInvitation,
  loadingOverlay,
}) => {
  
  return (
    <Dialog
      header="Choose the Template"
      visible={visible}
      modal
      onHide={onHide}
      className="template-dialog"
    //   footer={
    //     <div>
    //       <p style={{ color: "red" }}>{selectedTemplateError}</p>
    //           <Button
    //       label="Choose this template"
    //       icon="pi pi-check"
    //       disabled={loadingOverlay}
    //       onClick={() => {
    //         // pick current template
    //         setSelectedTemplate(eventimages[currentIndex]?.name);
    //         // then submit
    //         handleTemplateSubmit();
    //       }}
    //     />
    //     </div>
    //   }
    >
      {loadingOverlay ? (
        <div
          style={{
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
          <p style={{ marginTop: "8px" }}>Preparing templates...</p>
        </div>
      ) : imageloading ? (
        <h3 style={{ textAlign: "center" }}>
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
        </h3>
      ) : (<>
             {/* Image counter */}
              <div className="image-counter">
                {currentIndex + 1} / {eventimages.length}
              </div>
       
        <div className="image-preview">
  <div className="single-image-container">
    {/* Preview */}
    <div style={{ pointerEvents: "none", userSelect: "none" }}>
      <div className="rsvp-wrapper-scaled">
        <div className="rsvp-scaled-inner">
          <RSVPInvitationPage_pooja
            EventDataForInvitation={EventDataForInvitation}
            imageUrl_as_prop={eventimages[currentIndex]?.url}
          />
        </div>
      </div>
    </div>
  </div>
</div>

        
               {/* Navigation arrows */}
               <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
 <div className="arrow-controls">
  {imagetemplateslength > 1 && (
    <Button
      icon="pi pi-chevron-left"
      onClick={handlePrev}
      className="arrow-button"
    />
  )}
</div>
<Button
  label="select"
  onClick={() => {
    console.log("clicked template");

    if (eventimages.length === 0) {
      handleTemplateSubmit(""); // pass directly
    } else {
      const chosen = eventimages[currentIndex]?.name;
      handleTemplateSubmit(chosen); // pass directly
    }
  }}
/>

<div className="arrow-controls">
  {imagetemplateslength > 1 && (
    <Button
      icon="pi pi-chevron-right"
      onClick={handleNext}
      className="arrow-button"
    />
  )}
</div>
</div>
        </>
      )}
    </Dialog>
  );
};

export default ChooseTemplateDialog;
